
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useCounties() {
  return useQuery({
    queryKey: ["counties"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("counties")
        .select(
          "id, name, slug, image_url, nursing_home_count, description, display_order, featured"
        )
        .order("display_order", { ascending: true });

      if (error) {
        console.error("Error fetching counties:", error);
        throw new Error("Failed to fetch counties");
      }

      // Process the data to ensure image_url is correctly formatted
      const processedData = data?.map(county => {
        // We're just returning the data as is here, and will handle URL processing in the components
        // But we can add any data transformations if needed in the future
        console.log(`County ${county.name}, image URL: ${county.image_url}`);
        return county;
      });

      return processedData || [];
    },
  });
}
